import { TableColumn } from "./TableColumn";

export class TableConfig{
    columns:TableColumn[] = [];
}
